import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';

class MemberHome {
	constructor() {
		this.wrapper = SelectorEngine.findOne('.p-members-home');
		if(!this.wrapper) {
			// Not a Become A Member Page.
			return;
		}
		this.init();
	}

	init() {
		this.referralCheck();
		this.setReferralAdvantageLink();
		this.referralAdvantageCheck();
	}


	setReferralAdvantageLink() {
		if(document.getElementById('share-advantage-container')) {
			let referralUrl = window.location.origin + 
			document.getElementById('share-advantage-container').getAttribute('data-dc-refer-url') + '?advantageMemberCode=' +  document.getElementById('share-advantage-container').getAttribute('data-current-username'); 
			
			// For email link
			let formattedBody = document.getElementById('share-advantage-container').getAttribute('data-dc-email-body') + '%0A' + referralUrl;
			let mailToLink = 'mailto:?subject=' + document.getElementById('share-advantage-container').getAttribute('data-dc-email-subject') + '&body=' + formattedBody;
			this.referralLinkGenerator('.share-advantage-mail', mailToLink);
	
			// For facebook link
			let facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + referralUrl;
			this.referralLinkGenerator('.share-advantage-facebook', facebookLink);
	
			// For twitter link
			let twitterLink = 'http://twitter.com/intent/tweet?text=' + document.getElementById('share-advantage-container').getAttribute('data-dc-email-subject') + '&url=' + referralUrl;
			this.referralLinkGenerator('.share-advantage-twitter', twitterLink);

			// For singles whatsapp link
			var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
			if(isMobile) {
				let mobileLink = 'https://api.whatsapp.com/send?text=' + formattedBody;
				this.referralLinkGenerator('.share-advantage-whatsapp', mobileLink);
			} else {
				let webLink = 'https://web.whatsapp.com/send?text=' + formattedBody;
				this.referralLinkGenerator('.share-advantage-whatsapp', webLink);
			}
		}

		
	}

	referralLinkGenerator(className, link) {
		document.querySelectorAll(className).forEach((el) => {
			el.href = link;
		});
	}

	async referralAdvantageCheck() {
		try {
			const advantageMemberCode = await localStorage.getItem('advantageMemberCode');
			if(advantageMemberCode) {
				this.updateAdvantageMemberCode(advantageMemberCode);
			}
		} catch(error) {
			console.error(error);
		}
	}

	async updateAdvantageMemberCode(memberCode) {
		const memberRefer = await Request.get(`/api/selfsubmission/InviteFriendsWithCounter/?username=${memberCode}`).catch((e) => {
			if(e.errorCode == '99') {
				return false;
			}
		});

		if(memberRefer.errors.errorcode == '00') {
			console.log(memberRefer.response.message);
			localStorage.removeItem('advantageMemberCode');
		}
		if(memberRefer.errors.errorcode == '01') {
			console.log(memberRefer.response.message);
		}
	}

	async referralCheck() {
		try {
			const referralCode = await localStorage.getItem('referralCode');
			if(referralCode) {
				if(this.updateReferFriend(referralCode)) {
					this.redirectToMatchSummary(referralCode);
				}
			}
		} catch(error) {
			console.error(error);
		}
	}

	async updateReferFriend(referralCode) {
		const refer = await Request.post(`/api/selfsubmission/UpdateReferFriend?contactId=${document.getElementById("contactId").value}&code=${referralCode}`).catch((e) => {
			if(e.errorCode == '99') {
				return false;
			}
		});

		if(refer.errors.errorcode == '00') {
			return true;
		}
	}

	async redirectToMatchSummary(referralCode) {
		const confirmationUrlElement = SelectorEngine.findOne('#referAFriendMatchConfirmationUrl');
		if(!confirmationUrlElement || !referralCode) {
			return;
		}
		const URL = `/api/selfsubmission/getReferFriendByCode?code=${referralCode}`;
		const response = await Request.get(URL).catch((error) => console.error(error));
		try {
			if(response.errors.errorcode == '00') {
				const matchId = response.response.match.id;
				const confirmationUrl = document.getElementById("referAFriendMatchConfirmationUrl").getAttribute('data-confirmation-url');
				const redirectUrl = `${confirmationUrl}?matchId=${matchId}`;
				localStorage.removeItem('referralCode');
				setTimeout(window.location.href = redirectUrl, 5000);
			}
		} catch(error) {
			console.error(error);
		}
	}
}

const globalMemberHome = new MemberHome();
export default globalMemberHome;
